import React from 'react';
import { graphql, useFragment } from 'react-relay';
import { useRouter } from 'react-resource-router';
import { Articles } from '../articles';
import { Portals } from '../portals';
import { RequestForms } from '../request-forms';
import type { resourcesFragment$key } from './__generated__/resourcesFragment.graphql';

export interface Props {
    term: string;
    result: resourcesFragment$key;
    showAllResults?: boolean;
    updateResultsCount: (count: number) => void;
}

export const Resources = ({ term, result, showAllResults, updateResultsCount }: Props) => {
    const data = useFragment<resourcesFragment$key>(
        graphql`
            fragment resourcesFragment on Query {
                helpObjectStore @required(action: THROW) {
                    __typename
                    ...articlesFragment
                    ...requestFormsFragment
                    ...portalsFragment
                }
            }
        `,
        result
    );

    const [{ location }] = useRouter();
    const pathname = location.pathname ?? '';

    if (pathname.includes('/articles/search')) {
        return (
            <Articles
                term={term}
                result={data.helpObjectStore}
                showAllResults={showAllResults}
                updateResultsCount={updateResultsCount}
            />
        );
    }

    return (
        <>
            <Articles
                term={term}
                result={data.helpObjectStore}
                showAllResults={showAllResults}
                updateResultsCount={updateResultsCount}
            />
            <RequestForms term={term} result={data.helpObjectStore} updateResultsCount={updateResultsCount} />
            <Portals term={term} result={data.helpObjectStore} updateResultsCount={updateResultsCount} />
        </>
    );
};
